import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { LayerApi } from '../../../api/layer-api';
import { MapLayerUsageApi } from '../../../api/map-layer-usage-api';
import { environment } from '../../../environment';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { CrashAccidentCauseFlags, CrashAccidentTypeFlags } from '../../../selectionOptions';
import { AoiService } from '../../../services/aoi.service';
import { GisToolsService } from '../../../services/gis-tools.service';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { BaseComponent } from '../../base.component';
var GlobalFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GlobalFilterComponent, _super);
    function GlobalFilterComponent(authService, UserSettingsService, changeDetectorRef, gisToolsService, aoiService, layerService, layerApi, mapLayerUsageApi, toSqlStringService, _vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.authService = authService;
        _this.UserSettingsService = UserSettingsService;
        _this.changeDetectorRef = changeDetectorRef;
        _this.gisToolsService = gisToolsService;
        _this.aoiService = aoiService;
        _this.layerService = layerService;
        _this.layerApi = layerApi;
        _this.mapLayerUsageApi = mapLayerUsageApi;
        _this.toSqlStringService = toSqlStringService;
        _this._active = false;
        _this.zoomOnApply = true;
        _this.queryName = 'mc-global';
        _this.activeChange = new EventEmitter();
        _this.user = null;
        _this.loading = false;
        _this.allDistricts = [];
        _this.allCounties = [];
        _this.init();
        return _this;
    }
    Object.defineProperty(GlobalFilterComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = BooleanConverter(value);
            value ? this.activate() : this.deactivate();
            this.activeChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlobalFilterComponent.prototype, "maxYear", {
        get: function () {
            return new Date().getFullYear() + 11;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlobalFilterComponent.prototype, "crashAccidentTypeFlagsSelections", {
        get: function () {
            return CrashAccidentTypeFlags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlobalFilterComponent.prototype, "crashAccidentCauseFlagsSelections", {
        get: function () {
            return CrashAccidentCauseFlags;
        },
        enumerable: true,
        configurable: true
    });
    GlobalFilterComponent.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapRef = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GlobalFilterComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userSubscriber) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.authService.GetCurrentUser().subscribe(function (user) {
                                _this.user = user;
                                if (user && user.id) {
                                    _this.UserSettingsService.GetSettingValue('userSettings', _this.appName, user.emailAddress).subscribe(function (results) {
                                        if (results) {
                                            _this.defaults = [];
                                            if (results.districts) {
                                                _this.defaults.push({ name: 'districts', value: results.districts });
                                            }
                                            if (results.counties) {
                                                _this.defaults.push({ name: 'counties', value: results.counties });
                                            }
                                            _this.useDefaults();
                                            _this.changeDetectorRef.detectChanges();
                                        }
                                    });
                                }
                            })];
                    case 1:
                        _a.userSubscriber = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.load();
                        return [2 /*return*/];
                }
            });
        });
    };
    GlobalFilterComponent.prototype.deactivate = function () {
        this.previousExtraQueryConfigurations = this.extraQueryConfigurations;
        this.extraQueryConfigurations = null;
    };
    GlobalFilterComponent.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, dataCalls, mapData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        dataCalls = [
                            this.gisToolsService.getAllDistricts('districtNumber,counties{countyCode}'),
                            this.gisToolsService.getAllCounties('countyCode,name,districtNumber'),
                            // get years based on SAP-PM - CY Plan Snapshot layer
                            this.layerService.getDistinctValuesNoQuery(environment.layers.find(function (layer) { return layer.name === 'sapCYPlanSnapshot'; }).id, 'CALENDAR_YEAR')
                        ];
                        return [4 /*yield*/, Promise.all(dataCalls)];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), this.allDistricts = _a[0], this.allCounties = _a[1], this.sapCalendarYears = _a[2];
                        this.districts = this.getDistrictItems();
                        this.counties = this.getCountyItems();
                        if (this.mapRef.mapcoreViewProps.data) {
                            mapData = JSON.parse(this.mapRef.mapcoreViewProps.data);
                            if (mapData && mapData.paramConfig) {
                                this.extraQueryConfigurations = mapData.paramConfig;
                                this.setExtraQueryConfigurationDefaults();
                            }
                        }
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    GlobalFilterComponent.prototype.setExtraQueryConfigurationDefaults = function () {
        var e_1, _a;
        var remove = [];
        var configuredTypes = [];
        try {
            for (var _b = tslib_1.__values(this.extraQueryConfigurations), _c = _b.next(); !_c.done; _c = _b.next()) {
                var config = _c.value;
                var uniqueType = config.type + (!!config.label ? "-" + config.label : '');
                if (configuredTypes.includes(uniqueType)) {
                    config.duplicateType = true;
                }
                else {
                    configuredTypes.push(uniqueType);
                }
                switch (config.type) {
                    case 'CYFY':
                        config.value = 'fy';
                        break;
                    case 'SEALCOAT':
                        config.value = 'true';
                        break;
                    case 'COMPLETED_VS_SAP':
                        config.value = 'REMOVE';
                        break;
                    case 'NOCO_VS_PAYROLL':
                        config.value = 'F';
                        break;
                    case 'SAP_CALENDAR_YEAR':
                        config.value = this.sapCalendarYears[this.sapCalendarYears.length - 1].toString();
                        break;
                    case 'YEAR':
                        config.value = { operator: '', year: null, yearType: 'cy' };
                        break;
                    case 'DATERANGE':
                        config.value = { from: '', to: '' };
                        break;
                    case 'CRASHFLAG':
                        config.value = { accidentTypes: [], accidentCauses: [] };
                        break;
                    case 'CURRENT_PREDICTED':
                    case 'PROJECTED':
                        config.value = { projectedYear: new Date().getFullYear(), which: 'both' };
                        break;
                    case 'DEPENDENT_FIELDS':
                        config.value = {
                            primary: [],
                            dependant: []
                        };
                        this.getDistinctValues(config);
                        break;
                    case 'GENERIC':
                    case 'CONDITION':
                    case 'CALCULATED_COLUMN_REPLACEMENT':
                        config.value = [];
                        break;
                    case 'CTY':
                        // County Code filter not needed
                        remove.push(config);
                        break;
                    case 'BOOLEAN':
                    default:
                        console.warn("Map Filter Configuration " + config.type + " Default Values Not Implemented", config);
                        break;
                }
                config.value = this.previousExtraQueryConfigurationValue(config.type) || config.value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (remove.length) {
            this.extraQueryConfigurations = this.extraQueryConfigurations.filter(function (config) { return !remove.includes(config); });
        }
    };
    GlobalFilterComponent.prototype.previousExtraQueryConfigurationValue = function (type) {
        var retVal = null;
        if (this.previousExtraQueryConfigurations) {
            var prev = this.previousExtraQueryConfigurations.find(function (config) { return config.type === type; });
            if (prev) {
                retVal = prev.value;
            }
        }
        return retVal;
    };
    GlobalFilterComponent.prototype.onSettingChange = function (setting) {
        var e_2, _a;
        if (setting === 'districts') {
            this.counties = this.getCountyItems();
        }
        if (['districts', 'counties'].includes(setting) && this.extraQueryConfigurations) {
            try {
                for (var _b = tslib_1.__values(this.extraQueryConfigurations), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var config = _c.value;
                    if (config.type === 'DEPENDENT_FIELDS') {
                        this.getDistinctValues(config);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        this.changeDetectorRef.detectChanges();
    };
    GlobalFilterComponent.prototype.useDefaults = function () {
        var e_3, _a;
        if (this.defaults) {
            try {
                for (var _b = tslib_1.__values(this.defaults), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var setting = _c.value;
                    switch (setting.name) {
                        case 'districts':
                            this.selectedDistricts = setting.value;
                            this.counties = this.getCountyItems();
                            break;
                        case 'counties':
                            this.selectedCounties = setting.value;
                            break;
                        default:
                            break;
                    }
                    this.onSettingChange(setting.name);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    GlobalFilterComponent.prototype.apply = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchCriteria, counties, mapCoreViewProps, isSystemMap, districts, filteredLayers, queryLayerIds_1, filterLayers;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        if (!this.beforeApply) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.beforeApply()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.aoiService.clearSearchCriterias();
                        searchCriteria = [];
                        counties = this.getCountiesFromSelections();
                        if (counties.length) {
                            searchCriteria.push({
                                type: 'county',
                                countyCodes: counties
                            });
                        }
                        else {
                            searchCriteria.push({ type: 'state' });
                        }
                        mapCoreViewProps = this.mapRef.mapcoreViewProps;
                        isSystemMap = mapCoreViewProps.isSystem;
                        if (isSystemMap) {
                            districts = this.getDistrictFromSelections();
                            if (districts && districts.length && districts.length > 0) {
                                districts.forEach(function (district) {
                                    _this.mapLayerUsageApi.saveMapUsage(mapCoreViewProps.id, JSON.stringify(searchCriteria), district);
                                });
                            }
                        }
                        this.aoiService.setSearchCriterias(searchCriteria);
                        return [4 /*yield*/, this.aoiService.showBySearchCriterias(true, this.zoomOnApply, true, true, true)];
                    case 3:
                        filteredLayers = _a.sent();
                        if (this.extraQueryConfigurations) {
                            this.syncExtraQueryConfigurationValues();
                            queryLayerIds_1 = this.extraQueryConfigurations.map(function (qc) { return qc.layers; }).flat();
                            filterLayers = this.layerService.mapLayers.mapImage.filter(function (layer) {
                                return layer.mapcoreProps &&
                                    (queryLayerIds_1.includes(layer.mapcoreProps.id) ||
                                        queryLayerIds_1.includes(layer.mapcoreProps.parentId) ||
                                        queryLayerIds_1.includes(layer.mapcoreProps.idFromSavedLayer));
                            });
                            this.clearFilter(filterLayers);
                            this.filterLayers(filterLayers);
                        }
                        if (searchCriteria[0].type === 'state' && filteredLayers && filteredLayers.length) {
                            this.layerService.zoomToLayer(filteredLayers.map(function (layer) { return layer.id; }));
                        }
                        this.loading = false;
                        this.active = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    GlobalFilterComponent.prototype.syncExtraQueryConfigurationValues = function () {
        var e_4, _a;
        var _loop_1 = function (config) {
            var mainEQC = this_1.extraQueryConfigurations.find(function (eqc) { return eqc.type === config.type; });
            config.value = mainEQC.value;
        };
        var this_1 = this;
        try {
            for (var _b = tslib_1.__values(this.extraQueryConfigurations.filter(function (eqc) { return eqc.duplicateType; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                var config = _c.value;
                _loop_1(config);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    GlobalFilterComponent.prototype.getCountiesFromSelections = function () {
        var retVal = [];
        if ((this.selectedDistricts && this.selectedDistricts.length) || (this.selectedCounties && this.selectedCounties.length)) {
            if (this.selectedDistricts && this.selectedDistricts.length && (!this.selectedCounties || !this.selectedCounties.length)) {
                this.selectedCounties = this.getCountiesFromSelectedDistricts().map(function (county) { return "county-" + county.countyCode; });
            }
            if (this.selectedCounties && this.selectedCounties.length) {
                retVal.push.apply(retVal, tslib_1.__spread(this.selectedCounties.map(function (county) { return county.replace('county-', ''); })));
            }
        }
        return retVal;
    };
    GlobalFilterComponent.prototype.getDistrictFromSelections = function () {
        var _this = this;
        var retVal = [];
        if (this.selectedDistricts && this.selectedDistricts.length && this.selectedDistricts.length > 0) {
            this.selectedDistricts.forEach(function (selectedDistrict) {
                var districtNumber = selectedDistrict.replace('district-', '');
                if (!retVal.includes(parseInt(districtNumber, 0))) {
                    retVal.push(parseInt(districtNumber, 0));
                }
            });
        }
        if (this.selectedCounties && this.selectedCounties.length && this.selectedCounties.length > 0) {
            var counties = this.selectedCounties.map(function (countyStr) {
                var ctyCode = countyStr.replace('county-', '');
                var matchingCounty = _this.allCounties.find(function (county) { return county.countyCode.toString() === ctyCode; });
                return matchingCounty;
            });
            if (counties && counties.length && counties.length > 0) {
                counties.forEach(function (county) {
                    if (!retVal.includes(parseInt(county.districtNumber, 0))) {
                        retVal.push(parseInt(county.districtNumber, 0));
                    }
                });
            }
        }
        return retVal;
    };
    GlobalFilterComponent.prototype.clearFilter = function (filterLayers) {
        var _this = this;
        var e_5, _a;
        try {
            for (var filterLayers_1 = tslib_1.__values(filterLayers), filterLayers_1_1 = filterLayers_1.next(); !filterLayers_1_1.done; filterLayers_1_1 = filterLayers_1.next()) {
                var layer = filterLayers_1_1.value;
                if (layer.mapcoreProps.query) {
                    if (layer.mapcoreProps.query.name === this.queryName) {
                        layer.mapcoreProps.query = {};
                        layer.mapcoreProps.needsRefresh = true;
                    }
                    else if (layer.mapcoreProps.query.subqueries && layer.mapcoreProps.query.subqueries.length && layer.mapcoreProps.query.subqueries.some(function (x) { return x.name === _this.queryName; })) {
                        layer.mapcoreProps.query.subqueries = layer.mapcoreProps.query.subqueries.filter(function (x) { return x.name !== _this.queryName; });
                        layer.mapcoreProps.needsRefresh = true;
                    }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (filterLayers_1_1 && !filterLayers_1_1.done && (_a = filterLayers_1.return)) _a.call(filterLayers_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    GlobalFilterComponent.prototype.buildQuery = function (config) {
        var e_6, _a, e_7, _b, e_8, _c;
        var query = {};
        if (config.type === 'CYFY') {
            var filterParts = config.filter[config.value].split(' ').map(function (fp) { return fp.trim(); });
            query.field = filterParts[0];
            query.operator = filterParts[1] ? filterParts[1] : '=';
            query.value = filterParts[2] ? filterParts[2] : '';
        }
        else if (config.filter) {
            query.subqueries = [];
            try {
                for (var _d = tslib_1.__values(Object.keys(config.filter)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var filter = _e.value;
                    var filterParts = config.filter[filter].split(' ').map(function (fp) { return fp.trim(); });
                    query.subqueries.push({
                        field: filterParts[0],
                        operator: filterParts[1] ? filterParts[1] : '=',
                        value: filterParts[2] ? filterParts[2] : config.value.toString()
                    });
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        else if (config.type === 'SEALCOAT') {
            this.updateQuery(query, config);
        }
        else if (config.type === 'CRASHFLAG') {
            query.operator = 'OR';
            query.subqueries = [];
            try {
                for (var _f = tslib_1.__values(config.value.accidentTypes), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var type = _g.value;
                    query.subqueries.push({ field: type, operator: '=', value: '1' });
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_7) throw e_7.error; }
            }
            try {
                for (var _h = tslib_1.__values(config.value.accidentCauses), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var cause = _j.value;
                    query.subqueries.push({ field: cause, operator: '=', value: '1' });
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        else if (config.type === 'CURRENT_PREDICTED') {
            query.field = config.field;
            query.operator = '=';
            query.value = config.value.projectedYear ? config.value.projectedYear.toString() : null;
        }
        else if (config.type === 'PROJECTED') {
            query.operator = 'AND';
            query.subqueries = [];
            query.subqueries.push({
                field: config.field,
                operator: '=',
                value: config.value.projectedYear ? config.value.projectedYear.toString() : null
            });
        }
        else if (config.type === 'SAP_CALENDAR_YEAR' && config.value) {
            var longYear = config.value.toString();
            var shortYear = config.value.toString().slice(-2);
            var previousShortYear = (config.value - 1).toString().slice(-2);
            var calendarYearEqualFilter = {
                field: 'CALENDAR_YEAR',
                operator: '=',
                value: longYear
            };
            var calendarYearGreaterEqualFilter = {
                field: 'CALENDAR_YEAR',
                operator: '>=',
                value: longYear
            };
            var payrollDateFilter = {
                field: 'PAYROLL_DATE',
                operator: 'BETWEEN',
                value: longYear + "0101," + longYear + "1231"
            };
            var revisionFilter = {
                field: 'REVISION',
                operator: 'IN',
                value: previousShortYear + "-3," + shortYear + "-1"
            };
            var plannedRevisionFilter = {
                field: 'REVISION',
                operator: 'IN',
                value: previousShortYear + "-2," + shortYear + "-2"
            };
            query.subqueries = [calendarYearEqualFilter, calendarYearGreaterEqualFilter, payrollDateFilter, revisionFilter, plannedRevisionFilter];
        }
        else if (config.value && !['DEPENDENT_FIELDS'].includes(config.type)) {
            this.dependantFieldsQuery(config, query);
        }
        this.setQueryName(query);
        return query;
    };
    GlobalFilterComponent.prototype.filterLayers = function (filterLayers) {
        var e_9, _a;
        var _loop_2 = function (config) {
            var e_10, _a;
            var query = this_2.buildQuery(config);
            try {
                for (var _b = tslib_1.__values(filterLayers.filter(function (fl) { return config.layers.includes(fl.mapcoreProps.id) || config.layers.includes(fl.mapcoreProps.parentId) || config.layers.includes(fl.mapcoreProps.idFromSavedLayer); })), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var layer = _c.value;
                    this_2.layerService.updateLayerName(config, layer.mapcoreProps);
                    var filtered = this_2.configureLayerForColumnMap(config, layer);
                    if (query && ((query.subqueries && query.subqueries.length) || (query.field && (query.value !== undefined && query.value !== '')))) {
                        var layerQuery = tslib_1.__assign({}, query);
                        if (config.type === 'CURRENT_PREDICTED') {
                            if (layer.mapcoreProps.name.toUpperCase().includes('(CURRENT)')) {
                                layerQuery.operator = '<';
                            }
                            else if (layer.mapcoreProps.name.toUpperCase().includes('(PROJECTED)')) {
                                layerQuery.operator = '>=';
                            }
                            if (config.compareFullDate) {
                                layerQuery.value = this_2.getFullDate(layerQuery.value);
                            }
                        }
                        if (config.type === 'PROJECTED') {
                            this_2.projectedFilter(layerQuery, config, layer.mapcoreProps.name.toUpperCase());
                        }
                        if (config.type === 'CYFY') {
                            delete layerQuery.name;
                        }
                        if (config.type === 'SAP_CALENDAR_YEAR' && config.value) {
                            this_2.sapCalendarFilter(layerQuery, layer.mapcoreProps.name.toUpperCase());
                        }
                        this_2.updateLayerFilter(layer, config, layerQuery);
                    }
                    else if (filtered || layer.mapcoreProps.needsRefresh) {
                        this_2.layerService.updateLayerFilter(layer, layer.mapcoreProps.query);
                        layer.mapcoreProps.needsRefresh = false;
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_10) throw e_10.error; }
            }
        };
        var this_2 = this;
        try {
            for (var _b = tslib_1.__values(this.extraQueryConfigurations.filter(function (qc) { return qc.value && qc.value !== 'null'; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                var config = _c.value;
                _loop_2(config);
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_9) throw e_9.error; }
        }
        this.layerService.refreshLayers();
    };
    GlobalFilterComponent.prototype.updateLayerFilter = function (layer, config, layerQuery) {
        var e_11, _a;
        if (layer.mapcoreProps.query) {
            var fields_1 = null;
            if (config.type === 'CYFY') {
                fields_1 = Object.values(config.filter).map(function (f) { return f.split(' ')[0].trim().toUpperCase(); });
            }
            if (config.type === 'SAP_CALENDAR_YEAR' && config.value) {
                fields_1 = layerQuery.subqueries.map(function (subq) { return subq.field.toUpperCase(); });
            }
            var toRemove = null;
            if (layer.mapcoreProps.query.subqueries) {
                toRemove = layer.mapcoreProps.query.subqueries.filter(function (subquery) {
                    if (fields_1 && fields_1.includes(subquery.field.toUpperCase())) {
                        if (layerQuery.value === 'XX') {
                            layerQuery.value = subquery.value;
                        }
                        return true;
                    }
                    else if (config.field) {
                        if (config.type === 'PROJECTED' && subquery.subqueries) {
                            return true;
                        }
                        else {
                            return subquery.field ? subquery.field.toUpperCase() === config.field.toUpperCase() : false;
                        }
                    }
                    else if (config.filter) {
                        return Object.keys(config.filter).map(function (x) { return x.toUpperCase(); }).includes(subquery.field.toUpperCase());
                    }
                    return false;
                });
                if (toRemove.length) {
                    try {
                        for (var toRemove_1 = tslib_1.__values(toRemove), toRemove_1_1 = toRemove_1.next(); !toRemove_1_1.done; toRemove_1_1 = toRemove_1.next()) {
                            var remove = toRemove_1_1.value;
                            layer.mapcoreProps.query.subqueries.splice(layer.mapcoreProps.query.subqueries.indexOf(remove), 1);
                        }
                    }
                    catch (e_11_1) { e_11 = { error: e_11_1 }; }
                    finally {
                        try {
                            if (toRemove_1_1 && !toRemove_1_1.done && (_a = toRemove_1.return)) _a.call(toRemove_1);
                        }
                        finally { if (e_11) throw e_11.error; }
                    }
                }
            }
            else {
                if (fields_1 && layer.mapcoreProps.query.field && fields_1.includes(layer.mapcoreProps.query.field.toUpperCase())) {
                    if (layerQuery.value === 'XX') {
                        layerQuery.value = layer.mapcoreProps.query.value;
                    }
                    toRemove = true;
                }
                else if (config.field) {
                    toRemove = layer.mapcoreProps.query.field ? layer.mapcoreProps.query.field.toUpperCase() === config.field.toUpperCase() : false;
                }
                else if (config.filter && layer.mapcoreProps.query.field) {
                    toRemove = Object.keys(config.filter).map(function (x) { return x.toUpperCase(); }).includes(layer.mapcoreProps.query.field.toUpperCase());
                }
                else {
                    toRemove = false;
                }
                if (toRemove) {
                    layer.mapcoreProps.query = {};
                }
            }
        }
        if (layerQuery.value !== 'REMOVE') {
            var finalFilter = this.createFinalFilter(layerQuery, layer);
            this.layerService.updateLayerFilter(layer, finalFilter);
        }
    };
    GlobalFilterComponent.prototype.createFinalFilter = function (layerQuery, layer) {
        var e_12, _a;
        var finalFilter;
        if (layerQuery.operator !== 'OR' && layerQuery.subqueries && layerQuery.subqueries.length) {
            try {
                for (var _b = tslib_1.__values(layerQuery.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var query = _c.value;
                    if (!finalFilter) {
                        finalFilter = this.toSqlStringService.addFilter(layer.mapcoreProps.query, query);
                    }
                    else {
                        finalFilter = this.toSqlStringService.addFilter(finalFilter, query);
                    }
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_12) throw e_12.error; }
            }
        }
        else {
            finalFilter = this.toSqlStringService.addFilter(layer.mapcoreProps.query, layerQuery);
        }
        return finalFilter;
    };
    GlobalFilterComponent.prototype.projectedFilter = function (query, config, layerName) {
        var currentYear = new Date().getFullYear().toString();
        var projectedYear = query.subqueries[0].value.toString();
        // Clearing filter options and updating based on date or year config.
        query.subqueries = [];
        if (layerName.toUpperCase().includes('(CURRENT)')) {
            if (config.compareFullDate) {
                query.operator = 'AND';
                query.subqueries.push({
                    field: config.field,
                    operator: '<=',
                    value: this.getFullDate(currentYear)
                });
            }
        }
        else {
            query.operator = 'AND';
            query.subqueries.push({
                field: config.field,
                operator: '>=',
                value: config.compareFullDate ? this.getFullDate(currentYear) : currentYear
            });
            query.subqueries.push({
                field: config.field,
                operator: '<=',
                value: config.compareFullDate ? this.getEndDayOfYear('-', projectedYear) : projectedYear
            });
        }
    };
    GlobalFilterComponent.prototype.sapCalendarFilter = function (query, layerName) {
        var tempSubquery = [];
        if (layerName.toUpperCase().includes('COMPLETED')) {
            // payroll date
            tempSubquery.push(query.subqueries[2]);
        }
        else if (layerName.toUpperCase().includes('CURRENT')) {
            // calendar year greater or equal
            tempSubquery.push(query.subqueries[1]);
            // revision
            tempSubquery.push(query.subqueries[3]);
        }
        else if (layerName.toUpperCase().includes('ORIGINAL')) {
            // calendar year equal
            tempSubquery.push(query.subqueries[0]);
        }
        else if (layerName.toUpperCase().includes('ACTIVITIES')) {
            // calendar year greater or equal
            tempSubquery.push(query.subqueries[1]);
            // planned revision
            tempSubquery.push(query.subqueries[4]);
        }
        if (tempSubquery.length) {
            query.subqueries = tempSubquery;
        }
    };
    GlobalFilterComponent.prototype.getEndDayOfYear = function (delimiter, year) {
        if (delimiter === void 0) { delimiter = ''; }
        return [year, '12', '31'].join(delimiter);
    };
    GlobalFilterComponent.prototype.configureLayerForColumnMap = function (config, layer) {
        var retVal = false;
        if (config.columnMap) {
            var id = layer.mapcoreProps.parentId || layer.mapcoreProps.id;
            var ids = Object.keys(config.columnMap).map(Number);
            if (ids.includes(id)) {
                var columnMap = config.columnMap[id];
                if (config.value.primary.length) {
                    layer.mapcoreProps.query = this.toSqlStringService.addFilter(layer.mapcoreProps.query, {
                        field: columnMap.fieldName,
                        operator: 'IN',
                        value: config.value.primary.join(','),
                        name: this.queryName
                    });
                    retVal = true;
                }
                if (columnMap.dependentFieldName && config.value.dependant.length) {
                    layer.mapcoreProps.query = this.toSqlStringService.addFilter(layer.mapcoreProps.query, {
                        field: columnMap.dependentFieldName,
                        operator: 'IN',
                        value: config.value.dependant.join(','),
                        name: this.queryName
                    });
                    retVal = true;
                }
            }
        }
        return retVal;
    };
    GlobalFilterComponent.prototype.cancel = function () {
        this.active = false;
    };
    GlobalFilterComponent.prototype.getDistrictItems = function () {
        return this.allDistricts.map(function (district) { return ({
            name: "district-" + district.districtNumber,
            label: "District " + district.districtNumber,
            value: district.districtNumber
        }); });
    };
    GlobalFilterComponent.prototype.getCountyItems = function () {
        var availableCounties = this.getCountiesFromSelectedDistricts() || this.allCounties;
        return availableCounties.map(function (county) { return ({
            name: "county-" + county.countyCode,
            label: county.name,
            value: county.countyCode
        }); });
    };
    GlobalFilterComponent.prototype.getCountiesFromSelectedDistricts = function () {
        var _this = this;
        var retVal = null;
        if (this.selectedDistricts && this.selectedDistricts.length) {
            var districts_1 = this.allDistricts.filter(function (dis) { return _this.selectedDistricts.map(function (v) { return v.replace('district-', ''); }).includes(dis.districtNumber); });
            retVal = this.allCounties.filter(function (cty) { return districts_1.map(function (dis) { return dis.counties.map(function (c) { return c.countyCode; }); }).flat().includes(cty.countyCode); });
        }
        return retVal;
    };
    GlobalFilterComponent.prototype.getDistinctValues = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, primaryTable, dependantTable, query, counties;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        primaryTable = config.primaryOptionsTableNames[0].split('.');
                        dependantTable = config.dependentOptionsTableNames[0].split('.');
                        query = null;
                        counties = this.getCountiesFromSelections();
                        if (counties.length) {
                            query = {
                                field: config.countyOptionsColName,
                                operator: 'IN',
                                value: counties.join(',')
                            };
                        }
                        return [4 /*yield*/, Promise.all([
                                this.layerApi.getColumnDistinctValues(primaryTable[1], primaryTable[0], config.field, query),
                                this.layerApi.getColumnDistinctValues(dependantTable[1], dependantTable[0], config.dependentField, query)
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), config.options = _a[0], config.dependentOptions = _a[1]; // TODO: May need to get distinct from multiple primary or multiple dependant tables
                        return [2 /*return*/];
                }
            });
        });
    };
    GlobalFilterComponent.prototype.getFullDate = function (year) {
        var fullDate = new Date();
        fullDate.setFullYear(Number(year));
        return fullDate.getFullYear() + "-" + (fullDate.getMonth() + 1).toString().padStart(2, '0') + "-" + fullDate.getDate().toString().padStart(2, '0');
    };
    GlobalFilterComponent.prototype.updateQuery = function (query, config) {
        query.field = config.field;
        query.value = '';
        if (config.value === 'false') {
            //is MPMS
            if (config.label.indexOf('MPMS') > -1) {
                query.operator = 'NOT IN';
                query.value = '00037';
            }
            else if (config.label.indexOf('SAP')) {
                query.operator = 'NOT IN';
                query.value = '712401,712404';
            }
            else {
                query.operator = 'IS NULL';
            }
        }
        else {
            query.operator = 'IS NOT NULL';
        }
    };
    GlobalFilterComponent.prototype.dependantFieldsQuery = function (config, query) {
        if (Array.isArray(config.value) && config.value.length) {
            query.field = config.field;
            query.operator = 'IN';
            query.value = config.value.join(',');
        }
        else {
            query.field = config.field;
            query.operator = '=';
            query.value = config.value ? config.value.toString() : null;
        }
    };
    GlobalFilterComponent.prototype.setQueryName = function (query) {
        var _this = this;
        if (query.field) {
            query.name = this.queryName;
        }
        else if (query.subqueries && query.subqueries.length) {
            query.subqueries.forEach(function (sq) { return sq.name = _this.queryName; });
        }
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], GlobalFilterComponent.prototype, "zoomOnApply", void 0);
    return GlobalFilterComponent;
}(BaseComponent));
export { GlobalFilterComponent };
